import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import React from "react";
import { OverlayTrigger } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import TOOL_TIP from "../../../tooltip/ToolTip.component";
import TimingListStyles from "./TimingList.styles";
import { ITimingListItem } from "./TimingList.types";

const TIMING_LIST_ITEM: React.FC<ITimingListItem> = (
  props: ITimingListItem
) => {
  const { value, label } = props;
  const sendDataToGTM = useGTMDispatch();

  return (
    <TimingListStyles.TimingListItem
      data-testid={`timing-list-item_${label}`}
      className="timing-list-item"
      direction={
        /* istanbul ignore next */ isMobile ? "vertical" : "horizontal"
      }
      gap={/* istanbul ignore next */ isMobile ? 0 : 2}
    >
      <div className="label-cell">
        {
          <OverlayTrigger
            trigger="click"
            rootClose
            transition
            placement={/* istanbul ignore next */ isMobile ? "bottom" : "right"}
            onToggle={
              /* istanbul ignore next */ (nextShow: boolean) => {
                if (nextShow) {
                  sendDataToGTM({
                    event: "eventTracking",
                    category: "Construction",
                    action: `Tooltip Opened - ${label}`,
                    label: "Project Details - Timing List",
                  });
                }
              }
            }
            overlay={TOOL_TIP({
              timingLabel: label,
            })}
          >
            <span>{label}</span>
          </OverlayTrigger>
        }
      </div>
      <div>{value}</div>
    </TimingListStyles.TimingListItem>
  );
};

export { TIMING_LIST_ITEM };
